import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Route, Link, useParams, useNavigate } from 'react-router-dom';
import { AxiosInstance } from '../components/utils';
import "../css/bootstrap.min.css";
import "../css/animate.min.css";
import "../css/style.css";
import "../css/responsive.css";
import "../css/light-color.css";
import "../css/floatlabel.css";
import "../css/customstyle.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Breadcrumbs from '../components/sections/breadcrumbs';
import { Header } from '../components/sections/header';
import ScrollToTop from 'react-scroll-to-top';
import { ToastContainer, toast } from 'react-toastify';
import { Footer } from '../components/sections/footer';
import { ScheduleSection } from '../components/sections/schedulesection';
import MainWebFooter from '../components/sections/mainwebsite/mainwebfooter';


function EvtSchedule() {
    const [loading, setLoading] = useState(true);
    const [eventresp, setEventresp] = useState({} as any);
    const navigate = useNavigate();
    const { eventcode } = useParams();
    const queryParams = new URLSearchParams(window.location.search);
    const errmsg = queryParams.get("msg");


    useEffect(() => {
        if (eventcode == null) {
            navigate('/pagenotfound');
        }

        const fetchData = async () => {

            setLoading(true);

            const { data: response } = await AxiosInstance.get('/api/getevent?eventcode=' + eventcode);

            if (response.result != "Success" || response.data?.length == 0) {
                setLoading(false);
                navigate('/pagenotfound');
            }
            setLoading(false);
            setEventresp(response.data[0]);
            console.log(response.data);
        }
        fetchData();
    }, [navigate]);

    if (errmsg) {
        let msg = errmsg;
        if (errmsg == 'PAYMENT_FAILED') {
            msg = 'Payment Failed. Please retry.';
            toast.error(msg);
        }
        else if (errmsg == 'COUPONS_ALREADY_GENERATED') {
            msg = 'Coupons already sent to mail.';
            toast.error(msg);
        }
        else if (errmsg == 'GROUP_PAY_SUCCESS') {
            msg = 'Payment Successful. Please check mail for further details.';
            toast(msg);
        }
    }
    if (loading) {
        return (<div id="preloader">
            <div id="status">
                <div className="spinner"></div>
            </div>
        </div>);
    }
    else {
        return (
            <>
                {eventresp && <div className="antialiased light-vz circle-v ">

                    <Header eventInfo={eventresp} />
                    <h1 className="spacer-section"></h1>
                    <Breadcrumbs
                        items={[
                            { label: eventresp?.name || "Event", href: `/event/${eventresp?.eventcode}` },
                            { label: "Schedule", href: `/event/${eventresp?.eventcode}/schedule` },
                        ]}
                    />
                    <ScheduleSection eventInfo={eventresp} />

                    <MainWebFooter  />
                    <ScrollToTop component={<i className="fa fa-angle-up"></i>} smooth />
                    <ToastContainer position="bottom-right" />
                </div>}
            </>
        );
    }
}
export default EvtSchedule;
